<template>
    <div class="dialogItem">
        <!-- 选择信息弹框 -->
        <el-checkbox-group class="cardName" size="medium" v-model="loadOption">
            <el-checkbox-button style="display:block;" v-for="(item, index) in loadOptions" :key="index"
                :label="item.clientCard">
                <div class="infoSource">
                    <span><span class="nameSex">姓名:</span>{{ item.clientName }}</span>
                    <span><span class="nameSex">性别:</span>{{ item.clientSex }}</span>
                </div>
                <div class="infoSource"><span class="nameSex">手机号:</span>{{ item.clientMobile.replaceAll('，', ' ') }}
                </div>
                <div class="infoSource"><span class="nameSex">卡号:</span>{{ item.clientCard }}</div>
                <div class="infoSource"><span class="nameSex">信息来源:</span>{{ item.scName }}</div>
            </el-checkbox-button>
        </el-checkbox-group>
        <div class="footer">
            <el-button type="primary" icon="el-icon-arrow-left" @click="lastPage">上一页</el-button>
            <el-button type="primary" @click="nextpage">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
            <el-button type="danger" @click="cancel">取 消</el-button>
            <el-button type="primary" @click="addInfo">确 定</el-button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["loadOptions", 'formData'],
    data() {
        return {
            loadOption: [],
        }
    },
    methods: {
        nextpage() {
            let data = {
                clientCard: this.formData.cadCode,
                clientMobile: this.formData.mobile,
                clientName: this.formData.customerName,
                pageIndex: Lockr.get("selected") + 1,
            }
            api.requestQuiet("/register/getClientInformation", data, (res) => {
                console.log(res)
                if (res.result == true) {
                    //当前页数+1
                    this.loadOptions = res.data.mapList
                    Lockr.set("selected", res.data.pageIndex)
                } else {
                    _g.toast("warning", '已经是最后一页啦!');
                    Lockr.set("selected", res.data.pageIndex)
                }
            }, (err) => {
                this.loading = false
            });
        },
        lastPage() {
            if (Lockr.get("selected") < 2) {
                _g.toast("warning", '已经是第一页啦!');
            } else {
                let data = {
                    clientCard: this.formData.cadCode,
                    clientMobile: this.formData.mobile,
                    clientName: this.formData.customerName,
                    pageIndex: Lockr.get("selected") - 1,
                }
                api.requestQuiet("/register/getClientInformation", data, (res) => {
                    console.log(res)
                    if (res.result == true) {
                        this.loadOptions = res.data.mapList
                        Lockr.set("selected", res.data.pageIndex)
                    }
                }, (err) => {
                    this.loading = false
                });
            }
        },
        // 确定选择信息
        addInfo() {
            if (this.loadOption && this.loadOption != '') {
                let obj = {}
                // 提取数组中相同的元素
                let mobileArr = this.loadOptions.filter(item => this.loadOption.some(ele => ele === item.clientCard));
                // 多个电话号码数据处理 /拼接赋值.join('').replaceAll(' ', '/')
                let arr = (mobileArr.map((value) => value.clientMobile)).map(function (item) {
                    return item.replaceAll(' ', '/')
                })
                let mobileRes = arr.join('/')
                obj.clientMobile = mobileRes
                // 姓名处理
                let nameRes = mobileArr.map((value) => value.clientName).filter((num, index) => { return num !== '' }).join('/')
                obj.clientName = nameRes
                // 卡号处理
                let cardRes = mobileArr.map((value) => value.clientCard).filter((num, index) => { return num !== '' }).join('/')
                obj.clientCard = cardRes
                this.$emit("sure", obj);
            }
        },
        cancel() {
            this.$emit("close1");
        }
    }
}
</script>
<style scoped>
.dialogItem>>>.el-radio--medium.is-bordered {
    width: 500px !important;
    height: 115px !important;
    /* line-height: 20px; */
    margin-bottom: 20px !important;
}

.dialogItem>>>.el-checkbox-button--medium .el-checkbox-button__inner {
    text-align: left;
    width: 100%;
    margin-bottom: 10px;
    border-radius: 10px;
}

.dialogItem>>>.el-checkbox-button__inner {
    border-left: 1px solid #dcdfe6;
}

.dialogItem>>>.el-radio--medium.is-bordered .el-radio__label {
    font-size: 16px !important;
}

.dialogItem>>>.el-radio.is-bordered+.el-radio.is-bordered {
    margin-left: 0 !important;
}

.cardName {
    margin-bottom: 50px;
}

.infoSource {
    margin-bottom: 10px;
}

.dialogItem>>>.el-input--suffix .el-input__inner {
    padding-right: 5px;
}

.nameSex {
    font-weight: bold;
    margin-bottom: 10px;
    margin-left: 16px;
}
</style>